import { defineMessages } from 'react-intl';

export default defineMessages({
  PublicMy2nAppDownloadText: {
    defaultMessage:
      `To start using your My2N app, you'll need to <strong>download it first</strong>.` +
      `<p>Once installed, simply return to your <strong>activation email</strong> and follow the instructions to complete the setup.</p>`,
    id: 'public.my2n.app.download.text',
  },
  PublicMy2nAppDownloadTitle: {
    defaultMessage: 'Download the My2N mobile app',
    id: 'public.my2n.app.download.title',
  },
});
